const ServicesPage = () => {
  const services = [
    { id: 2, name: "Consultație + plan de tratament", price: "150 RON" },

    { id: 3, name: "Consultație + plan de tratament + scanare", price: "400 RON" },

    { id: 4, name: "Obturație de compozit", price: "De la 300 RON" },

    { id: 5, name: "Obturație de compozit armată cu pivot fizionomic", price: "De la 400 RON" },

    { id: 6, name: "Obturație cu glasionomer", price: "De la 250 RON" },

    { id: 7, name: "Pansament calmant + tratament mecanico-antiseptic", price: "200 RON" },

    { id: 8, name: "Pulpectomie vitală + obturație radiculară la dinte monoradicular", price: "De la 400 RON" },

    { id: 9, name: "Pulpectomie vitală + obturație radiculară la dinte pluriradicular", price: "De la 500 RON" },

    { id: 10, name: "Retratament endodontic la dinte monoradicular", price: "De la 450 RON" },

    { id: 11, name: "Retratament endodontic la dinte pluriradicular", price: "De la 550 RON" },

    { id: 12, name: "Detartraj cu ultrasunete + prophy jet + periaj", price: "300 RON" },

    { id: 13, name: "Extracție monoradiculari + sutură", price: "De la 300 RON" },

    { id: 14, name: "Extracție pluriradiculari + sutură", price: "De la 400 RON" },

    { id: 15, name: "Extracție cu alveolotomie", price: "De la 400 RON" },

    { id: 16, name: "Rezecție apicală", price: "De la 400 RON" },

    { id: 17, name: "Odontectomie molar inclus", price: "De la 800 RON" },

    { id: 18, name: "Implant dentar", price: "De la 2000 RON" },

    { id: 19, name: "Augumentare osoasă", price: "1800 RON" },

    { id: 20, name: "Proteză acrilică mobilizabilă", price: "2500 RON" },

    { id: 21, name: "Proteză Valplast", price: "3000 RON" },

    { id: 22, name: "Proteză scheletată", price: "4500 RON" },

    { id: 23, name: "Căptușire proteză / reparație proteză", price: "400 RON" },

    { id: 24, name: "Ablație / dinte", price: "100 RON" },

    { id: 25, name: "Gingivectomie", price: "200 RON" },

    { id: 26, name: "Dispozitiv corono-radicular", price: "300 RON" },

    { id: 27, name: "Coroană acrilică provizorie", price: "200 RON" },

    { id: 28, name: "Coroană metalo-ceramică", price: "800 RON" },

    { id: 29, name: "Coroană full zirconiu", price: "1000 RON" },

    { id: 30, name: "Coroană ceramică pe zirconiu", price: "1300 RON" },

    { id: 31, name: "Coroană integral ceramic", price: "1500 RON" },

    { id: 32, name: "Coroană pe implant dentar înșurubată", price: "De la 1800 RON" },

    { id: 33, name: "Coroană pe implant dentar înșurubată pe sistem multiunit", price: "De la 2500 RON" },

    { id: 34, name: "Fațete", price: "De la 1500 RON" },

    { id: 35, name: "Albire endodontică", price: "500 RON" },

    { id: 36, name: "Albire profesională, ambele arcade (fără gutiere)", price: "1000 RON" },

    { id: 37, name: "Aparat ortodontic fix cu brackeți metalici pe o arcadă dentară", price: "3000 RON" },

    { id: 38, name: "Aparat ortodontic mobil", price: "700 RON" },

    { id: 39, name: "Aparat ortodontic cu gutiere (Alignere)", price: "De la 8000 RON" }
  ];


  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">Servicii Stomatologice Oradea – Tratamente Dentare Artisan Stoma</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map(service => (
          <div key={service.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-300 text-center">
            <h3 className="text-xl font-bold text-gray-800 mb-2">{service.name}</h3>
            <p className="text-gray-600 mb-4">{service.description}</p>
              <span className="text-lg font-bold text-blue-600">{service.price}</span>

          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
